import type { MenuAgentContext } from "./types";

function normalize(text: string): string { return text.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, ""); }
function findItemByName(text: string, items: MenuAgentContext["items"]) {
  const needle = normalize(text); return items.find((item) => needle.includes(normalize(item.name))) ?? null;
}
function findVariantByName(text: string, items: MenuAgentContext["items"]) {
  const needle = normalize(text);
  for (const item of items) for (const variant of item.variants) {
    if (needle.includes(normalize(variant.name)) || needle.includes(normalize(`${item.name} ${variant.name}`))) return { item, variant };
  }
  return null;
}
export function menuMoney(minor: number | null, currency: string): string {
  return new Intl.NumberFormat("es-AR", { style: "currency", currency: currency || "ARS" }).format((Number(minor) || 0) / 100);
}
export function interpretMenuAgentMessage(message: string, context: MenuAgentContext): { error?: string; composedMessage?: string; summary?: string } {
  const priceMatch = message.match(/(\d+(?:[.,]\d{1,2})?)/);
  const wantsPrice = /precio|cuesta|vale|cambia(r)? el precio/i.test(message) && priceMatch;
  const wantsUnavailable = /agotad|sin stock|no (hay|queda)/i.test(message);
  const wantsReactivate = /reactiv|disponible de nuevo|volvi[oó]|ya hay/i.test(message);
  if (wantsPrice && priceMatch) {
    const found = findVariantByName(message, context.items);
    if (!found) return { error: "No encontré ese producto en tu carta. Probá escribiendo el nombre exacto." };
    const priceMinor = Math.round(parseFloat(priceMatch[1]!.replace(",", ".")) * 100);
    return { composedMessage: `precio ${found.variant.id} ${priceMinor}`, summary: `Cambiar el precio de “${found.item.name} · ${found.variant.name}” de ${menuMoney(found.variant.priceMinor, context.currency)} a ${menuMoney(priceMinor, context.currency)}.` };
  }
  if (wantsUnavailable || wantsReactivate) {
    const found = findItemByName(message, context.items);
    if (!found) return { error: "No encontré ese producto en tu carta. Probá escribiendo el nombre exacto." };
    return { composedMessage: `${wantsReactivate ? "reactivar" : "agotado"} ${found.id}`, summary: wantsReactivate ? `Marcar “${found.name}” como disponible otra vez.` : `Marcar “${found.name}” como agotado.` };
  }
  return { error: "No entendí bien qué querés cambiar. Probá con un precio o con marcar un producto como agotado/disponible." };
}
